import { useEffect, useState } from "react";
import { getMessageOfUser, getUsersList, sendMessageToUser } from "../../api/api";
import { errorNotify, sucessNotify } from "../../services/toast.notification";
import Spinner from '../../components/_common/Spinner';
import { Button, Col, Radio, RadioChangeEvent, Row, Tooltip,Image } from "antd";
import { StyledTextArea } from "./styles";
import { useAppDispatch, useAppSelector } from "../../redux/store/storehooks";
import { UpdateLabUsers } from "../../redux/reducers/labUsersSlice";
import {ExclamationCircleFilled} from '@ant-design/icons';

export interface InputProps {
    url: any
  }
const UsersList = ({url}:InputProps) =>{

    //url = "http://193.151.128.199:8086";

    const [isLoading,setIsLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [sendRes, setSendRes] = useState([]);
    const [radioVal, setRadioVal] = useState(0);
    const [userMessages, setUserMessages] = useState([]);

    const dispatch = useAppDispatch();
    const myStore = useAppSelector((state) => state)

    const [inputValues, setInputValue] = useState({
        subject:'',
        body:''
    });
  
    function handleChange(event: any) {       
        const { name, value } = event.target;       
        setInputValue({ ...inputValues, [name]: value });
    }

    const onChangeRadio = (e: RadioChangeEvent) => {
       // console.log('radio checked', e.target.value);
        setRadioVal(e.target.value);
        _getUserMessages(e.target.value);
    }
    

    const _getUserMessages =(userId:number)=>{
        if(userId != 0){
            getMessageOfUser(url,userId)
            .then((result:any) => {
                //let jsonResult = JSON.parse(result.data);
                setUserMessages(result.data.inboxmessageLists); 
                  
                console.log(result.data.inboxmessageLists); 
                setIsLoading(false);            
            })
            .catch((error) => {
              console.log(error);
              errorNotify(error.response.data.errorMessage,undefined,5000)
            })
        }
        else
            setUserMessages([]); 
        
    }

    const loadUsers = (url:string,baseType:number,tubeId:number,groupTestId:number,isForAdmit:boolean) => {
        getUsersList(url,baseType,tubeId,groupTestId,isForAdmit)
        .then((result:any) => {
            let jsonResult = JSON.parse(result.data.json);

            const userList:any = [];
            userList.push({
                "PRK_UsersID":0,
                "Str_UserFullName":"همه",
                "Int_IsLogin":false,
                "bit_AcountIsDisable":false
            });
            jsonResult.listOfUser.map((item:any)=>{
                userList.push(item) ;
            });

            setUsers(userList); 
            if(jsonResult.listOfUser === undefined)
                dispatch(UpdateLabUsers({labUsers:[]})) 
            else
                dispatch(UpdateLabUsers({labUsers:userList}))     
            //console.log(result.data.json); 
            setIsLoading(false);            
        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })
  }

  const sendMessage = (url:string,userId:number,subject:string,body:string) => {
   // console.log(url + " " + userId + " "+ subject +" "+ body);
    sendMessageToUser(url,userId,subject,body)
    .then((result:any) => {
        setSendRes(result.data.json);      
        console.log(result.data.json); 
        setIsLoading(false);
        sucessNotify("پیام ارسال شد!");
        _getUserMessages(userId);            
    })
    .catch((error) => {
      console.log(error);
      errorNotify(error.response.data.errorMessage,undefined,5000)
    })
}
    
    useEffect(()=>
    {
       // alert(myStore.auth.userId);
      loadUsers(url,9,0,0,false);
    },[]);

return(
        <div style={{maxHeight:'600px',overflow:'scroll'}}>
       
        { 
          isLoading === false &&(
            <Row>
                <Col lg={6} md={6} sm={24} xs={24}>
                    <div className="col-shadow">
                    <Radio.Group 
                        style={{marginTop:'15px'}}
                        onChange={onChangeRadio} value={radioVal}>
                            {myStore.labUsers.list.map((item:any) =>{
                               return(
                               <div>
                                    <Radio value={item.PRK_UsersID}>{item.Str_UserFullName}</Radio>
                                </div>)
                            })}
                    </Radio.Group>
                    </div>
                </Col>
                <Col lg={18} md={18} sm={24} xs={24}>

                <div style={{marginTop:'20px'}}> 
        {
            userMessages.map((item:any) =>{
              return(
                <>                
                        <div className="row d-flex mt-3" id={item.userId === radioVal? "left-side":""}>
                        <span>
                            <div className={item.userId === radioVal?"borderd-content":"unReadTicket"} style={{width:'80%',marginRight:'20px'}}>
                                <div className="title" style={{right:0}}>{item.subject}</div>
                                <div className="title" style={{left:0}}>{item.perSendDate}</div>

                            <div className="content">
                                <div className="row d-flex justify-content-around mt-3"> 
                                <p>{item.body}</p>                      
                                </div>


                                {!item.bit_read && item.userId !== radioVal &&
                            <div style={{float:'left'}}>
                                <Tooltip title="unread">
                                    <Image
                                        style={{width:'25px',position:'relative',left:'-30px',bottom:'5px'}}
                                        src='../assets/icon/doublecheck_icon1.png'
                                        />
                                </Tooltip>
                            </div>
                            }
                            {item.bit_read && item.userId !== radioVal &&
                                <div style={{float:'left'}}>
                                    <Tooltip title="read">
                                        <Image
                                            style={{width:'25px',position:'relative',left:'-30px',bottom:'5px'}}
                                            src='../assets/icon/doublecheck_icon.png'
                                        />
                                    </Tooltip>
                                </div>

                            }
                            </div>
                            
                            
                        </div>
                        </span>

                        </div>
                </>
              )
            }) 
        }
        </div>


        <div style={{marginTop:'15px',marginBottom:'15px',marginRight:'15px'}}>
            <div className="form-control"
                        style={{ marginBottom: '18px' }} >
                            <input
                            placeholder="عنوان پیام"
                            type="string"
                            autoComplete="false"
                            name="subject"
                            id="subject"
                            className="input-field"
                            onChange={(e) => handleChange(e)}
                            value={inputValues.subject}
                            />                                           
            </div>
            <div className="form-control"
                        style={{ marginBottom: '18px' }} >
                           <StyledTextArea
                            placeholder="متن پیام"
                            id="body"
                            name="body"
                            onChange={(e) => handleChange(e)}
                            value={inputValues.body}
                            />                                 
            </div>
            <Button type="primary" onClick={()=>sendMessage(url,radioVal,inputValues.subject,inputValues.body)} style={{backgroundColor:"blue",marginLeft:"15px",float:"left"}} >ارسال </Button>
        </div>
                </Col>
            </Row>

          )
          }
          {
            isLoading === true  && (
            <Spinner />
          )
        }
        </div>
    )

}

export default UsersList;